export enum AGENT_HUB_MCPS {
    /**
     * @value Basic Information
     */
    BASIC_INFORMATION = 'AGENT_HUB_MCPS.BASIC_INFORMATION',
    /**
     * @value Set up the basics of your MCP server: what it's called and how it works.
     */
    BASIC_INFORMATION_DESC = 'AGENT_HUB_MCPS.BASIC_INFORMATION_DESC',
    /**
     * @value MCP Connected
     * @description Notification displayed when successfully connected to MCP server.
     */
    CONNECT_MCP_CONNECTED = 'AGENT_HUB_MCPS.CONNECT_MCP_CONNECTED',
    /**
     * @value The connection failed
     * @description Title of the dialog when connection to mcp server has failed
     */
    CONNECT_MCP_CONNECTION_FAILED = 'AGENT_HUB_MCPS.CONNECT_MCP_CONNECTION_FAILED',
    /**
     * @value Check settings and try again
     * @description Displayedas description when the connection to mcp server has failed
     */
    CONNECT_MCP_CONNECTION_FAILED_DESC = 'AGENT_HUB_MCPS.CONNECT_MCP_CONNECTION_FAILED_DESC',
    /**
     * @value And fetch MCP's tools
     * @description Description of the login action to mcp server
     */
    CONNECT_MCP_DESCRIPTION = 'AGENT_HUB_MCPS.CONNECT_MCP_DESCRIPTION',
    /**
     * @value Connecting to MCP
     * @description Description displayed in dialog when user is connecting to mcp server to fetch tools
     */
    CONNECT_MCP_FETCHING_DESC = 'AGENT_HUB_MCPS.CONNECT_MCP_FETCHING_DESC',
    /**
     * @value Fetching tools
     * @description Title of the dialog displayed when fetching tools from MCP server
     */
    CONNECT_MCP_FETCHING_TITLE = 'AGENT_HUB_MCPS.CONNECT_MCP_FETCHING_TITLE',
    /**
     * @value We are connecting to the MCP server and retrieving the tools available for agents.
     */
    CONNECT_MCP_FETCHING_TOOLS_DESC = 'AGENT_HUB_MCPS.CONNECT_MCP_FETCHING_TOOLS_DESC',
    /**
     * @value Fetching available tools
     */
    CONNECT_MCP_FETCHING_TOOLS_TITLE = 'AGENT_HUB_MCPS.CONNECT_MCP_FETCHING_TOOLS_TITLE',
    /**
     * @value After authorization, we will fetch the available tools from this MCP server so they can be used by agents.
     */
    CONNECT_MCP_GET_CONSENT_DESC = 'AGENT_HUB_MCPS.CONNECT_MCP_GET_CONSENT_DESC',
    /**
     * @value Authorize this MCP server connection
     */
    CONNECT_MCP_GET_CONSENT_TITLE = 'AGENT_HUB_MCPS.CONNECT_MCP_GET_CONSENT_TITLE',
    /**
     * @value Log in to connect to MCP
     * @description Title of the dialog asking user to log in  mcp serveur
     */
    CONNECT_MCP_TITLE = 'AGENT_HUB_MCPS.CONNECT_MCP_TITLE',
    /**
     * @value {"one":"Deactivating this tool will remove it from any agents that currently use it. %LINEBREAK%Agents may stop working as expected until you update their configuration.","other":"Deactivating these tools will remove them from any agents that currently use them. %LINEBREAK%Agents may stop working as expected until you update their configuration."}
     * @description Description displayed in a dialog when the user wants to deactivate a tool in MCP server
     */
    DEACTIVATE_WARNING_DESC_PLURAL = 'AGENT_HUB_MCPS.DEACTIVATE_WARNING_DESC_PLURAL',
    /**
     * @value Deactivate %TOOL_NAME%?
     * @description Title of the dialog displayed when a user wants to deactivate a tool
     */
    DEACTIVATE_WARNING_TITLE = 'AGENT_HUB_MCPS.DEACTIVATE_WARNING_TITLE',
    /**
     * @value Deleting this MCP will remove all its tools from any agents that currently use them.
     * Agents may stop working as expected until you update their configuration.
     * @description Body of the delete confirmation dialog for an MCP connector (%NAME% is the MCP name)
     */
    DELETE_MCP_DESCRIPTION = 'AGENT_HUB_MCPS.DELETE_MCP_DESCRIPTION',
    /**
     * @value Edit MCP
     */
    EDIT_MCP = 'AGENT_HUB_MCPS.EDIT_MCP',
    /**
     * @value External MCP
     * @description Sub section title for external MCP server admin page
     */
    EXTERNAL_MCP = 'AGENT_HUB_MCPS.EXTERNAL_MCP',
    /**
     * @value Define the method used to retrieve tools list from the provider application.
     */
    GRANT_TYPE_DESC = 'AGENT_HUB_MCPS.GRANT_TYPE_DESC',
    /**
     * @value MCP
     * @description Page title for the MCP list section
     */
    MCP = 'AGENT_HUB_MCPS.MCP',
    /**
     * @value MCP server created successfully.
     * @description Notification displayed after creating a MCP server
     */
    MCP_SERVER_CREATED = 'AGENT_HUB_MCPS.MCP_SERVER_CREATED',
    /**
     * @value MCP server updated successfully.
     * @description Notification displayed after updating a MCP server
     */
    MCP_SERVER_UPDATED = 'AGENT_HUB_MCPS.MCP_SERVER_UPDATED',
    /**
     * @value MCP Server URL
     */
    MCP_SERVER_URL = 'AGENT_HUB_MCPS.MCP_SERVER_URL',
    /**
     * @value MCP Settings
     * @description Button label for edit MCP server settings button displayed in mcp server tools list page
     */
    MCP_SETTINGS = 'AGENT_HUB_MCPS.MCP_SETTINGS',
    /**
     * @value MCP Tools
     * @description Title for the MCP tools section in the backoffice
     */
    MCP_TOOLS = 'AGENT_HUB_MCPS.MCP_TOOLS',
    /**
     * @value %TOOLS_ACTIVATED% of %TOOLS_TOTAL% tools activated
     */
    MCP_TOOLS_ACTIVATED = 'AGENT_HUB_MCPS.MCP_TOOLS_ACTIVATED',
    /**
     * @value New MCP
     */
    NEW_MCP = 'AGENT_HUB_MCPS.NEW_MCP',
    /**
     * @value No tools available
     */
    NO_TOOLS_AVAILABLE = 'AGENT_HUB_MCPS.NO_TOOLS_AVAILABLE',
    /**
     * @value Check the MCP settings and update the scopes if needed. We will fetch the available tools after you save your changes.
     */
    NO_TOOLS_AVAILABLE_DESC_2 = 'AGENT_HUB_MCPS.NO_TOOLS_AVAILABLE_DESC_2',
    /**
     * @value {"one":"%NUMBER% tool","other":"%NUMBER% tools"}
     * @description Count label on the MCP tools list toolbar when the full list is loaded (no more pages). Counterpart of AGENT_HUB_MCPS.NUMBER_TOOLS_OUT_OF_MANY. Pluralized ICU value.
     */
    NUMBER_TOOLS = 'AGENT_HUB_MCPS.NUMBER_TOOLS',
    /**
     * @value {"one":"%NUMBER% tool out of many","other":"%NUMBER% tools out of many"}
     * @description Count label on the MCP tools list toolbar, shown next to the select-all checkbox when nothing is selected (paginated list, total unknown). Pluralized ICU value.
     */
    NUMBER_TOOLS_OUT_OF_MANY = 'AGENT_HUB_MCPS.NUMBER_TOOLS_OUT_OF_MANY',
    /**
     * @value {"one":"%NUMBER% tool selected","other":"%NUMBER% tools selected"}
     * @description Selected count label in the MCP tools list toolbar while tools are checked for a bulk action. Pluralized ICU value.
     */
    NUMBER_TOOLS_SELECTED = 'AGENT_HUB_MCPS.NUMBER_TOOLS_SELECTED',
    /**
     * @value OAuth2 Protocol
     */
    OAUTH2_PROTOCOL = 'AGENT_HUB_MCPS.OAUTH2_PROTOCOL',
    /**
     * @value Choose how this MCP connection authenticates with the provider and gets permission to access its tools.
     */
    OAUTH2_PROTOCOL_DESC = 'AGENT_HUB_MCPS.OAUTH2_PROTOCOL_DESC',
    /**
     * @value The provider fetches available tools for your agent.
     */
    PROVIDER_DESC = 'AGENT_HUB_MCPS.PROVIDER_DESC',
    /**
     * @value Update MCP
     * @description Confirm button of the warning dialog shown when editing an MCP server's OAuth scopes.
     */
    SCOPES_WARNING_CONFIRM = 'AGENT_HUB_MCPS.SCOPES_WARNING_CONFIRM',
    /**
     * @value Changing scopes may remove tools from this MCP. %LINEBREAK%If any removed tools are used by agents, those agents may stop working as expected until you update their configuration.
     * @description Body of the warning dialog shown when editing an MCP server's OAuth scopes. %LINEBREAK% is replaced by a line break.
     */
    SCOPES_WARNING_DESC = 'AGENT_HUB_MCPS.SCOPES_WARNING_DESC',
    /**
     * @value Update scopes?
     * @description Title of the warning dialog shown when editing an MCP server's OAuth scopes.
     */
    SCOPES_WARNING_TITLE = 'AGENT_HUB_MCPS.SCOPES_WARNING_TITLE',
    /**
     * @value {"one":"Tool is activated","other":"Tools are activated"}
     * @description Notification displayed when a tool has been activated (draft -> activate)
     */
    TOOL_ACTIVATED_PLURAL = 'AGENT_HUB_MCPS.TOOL_ACTIVATED_PLURAL',
    /**
     * @value {"one":"Tool is deactivated","other":"Tools are deactivated"}
     * @description Notification displayed when tool is deactivated
     */
    TOOL_DEACTIVATED_PLURAL = 'AGENT_HUB_MCPS.TOOL_DEACTIVATED_PLURAL',
    /**
     * @value Update tools
     * @description Button label on the built-in MCP server settings page that triggers a tool sync.
     */
    UPDATE_TOOLS = 'AGENT_HUB_MCPS.UPDATE_TOOLS',
}
